<script setup>
import { ref } from 'vue';
import SuccessModal from './SuccessModal.vue';
import QuestionDisapprovalModal from "@/components/approval-center/modals/QuestionDisapprovalModal.vue";

const questionValue = defineModel('question', {
  type: String,
  required: true,
});

const answerValue = defineModel('answer', {
  type: String,
  required: true,
});

const emit = defineEmits(['close', 'confirm']);
const showSuccessModal = ref(false);

const handleConfirm = () => {
  emit('confirm');
  showSuccessModal.value = true;
};
</script>

<template>
  <QuestionDisapprovalModal
    v-if="!showSuccessModal"
    v-model:question="questionValue"
    v-model:answer="answerValue"
    @close="emit('close')"
    @confirm="handleConfirm"
  />

  <SuccessModal
    v-else
    @close="emit('close')"
  />
</template>
